import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useCreate: useUnfollowCourse } = getCRUDHooks({
  entityName: 'unFollowCourse',
  create: ({ userId, courseId }: { userId: number; courseId: number }) =>
    clientApi.getOCClient().helpers.learningActivity.courses.unfollow(userId, courseId),
});

export {
  // eslint-disable-next-line import/prefer-default-export
  useUnfollowCourse,
};
